export default __webpack_public_path__ + "static/media/mobileIcon.fb2a48e5.svg";